import React from "react";
import { PageHeader } from "@finitless/shared/components";
import { useTranslation } from "react-i18next";
import { Icon } from "../../ui/UIElements/Icon";
import "../conversations/conversations-pages.css";

const VoiceCallsPage = ({ selectedBrand }) => {
  const { t } = useTranslation("reports");

  return (
    <div
      className="ordering-voice-calls-page space-y-4 sm:space-y-6"
      data-ordering-surface="voice-calls"
    >
      <PageHeader
        title={t("voiceCalls.header.title")}
        subtitle={t("voiceCalls.header.subtitle", {
          name: selectedBrand?.name || t("voiceCalls.header.defaultBusiness"),
        })}
      />

      <section className="border-border bg-card rounded-lg border p-4 shadow-[var(--od-shadow-1)]">
        <div className="py-12 text-center">
          <div className="bg-success-bg text-success mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-lg">
            <Icon name="Phone" className="h-7 w-7" />
          </div>
          <h3 className="text-foreground mb-2 text-lg font-medium tracking-tight">
            {t("voiceCalls.card.title")}
          </h3>
          <p className="text-muted-foreground mx-auto mb-6 max-w-2xl break-words">
            {t("voiceCalls.card.subtitle")}
          </p>
          <div className="mx-auto grid max-w-2xl grid-cols-1 gap-4 md:grid-cols-3">
            <div className="border-border bg-background rounded-md border p-4">
              <div className="text-foreground font-mono text-2xl font-semibold tabular-nums">
                324
              </div>
              <div className="text-muted-foreground text-sm">
                {t("voiceCalls.stats.totalCalls")}
              </div>
            </div>
            <div className="border-border bg-background rounded-md border p-4">
              <div className="text-foreground font-mono text-2xl font-semibold tabular-nums">
                3.2m
              </div>
              <div className="text-muted-foreground text-sm">
                {t("voiceCalls.stats.avgDuration")}
              </div>
            </div>
            <div className="border-border bg-background rounded-md border p-4">
              <div className="text-foreground font-mono text-2xl font-semibold tabular-nums">
                92%
              </div>
              <div className="text-muted-foreground text-sm">
                {t("voiceCalls.stats.resolutionRate")}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default VoiceCallsPage;
